
// Application environment configuration
// These values can be updated for your deployment environment

// Base URLs
export const APP_NAME = "VirtuStaff.ai";
export const API_BASE_URL = "https://api.virtustaff.ai";

// Production mode flag
export const IS_PRODUCTION = true;

// Supabase URL - always use the production URL for Slack integrations
export const SUPABASE_PROJECT_ID = "qzcgtvcifevlhmrobgia";
export const SUPABASE_URL = 
  import.meta.env.VITE_SUPABASE_URL || 
  `https://${SUPABASE_PROJECT_ID}.supabase.co`;

// LangSmith configuration
export const LANGSMITH_TRACING = import.meta.env.VITE_LANGSMITH_TRACING || "true";
export const LANGSMITH_ENDPOINT = import.meta.env.VITE_LANGSMITH_ENDPOINT || "https://api.smith.langchain.com";
export const LANGSMITH_PROJECT = import.meta.env.VITE_LANGSMITH_PROJECT || "virtustaff-ai";

// Slack integration endpoints
export const SLACK_ENDPOINT_BASE = `${SUPABASE_URL}/functions/v1`;
export const SLACK_WEBHOOK_RECEIVER = `${SLACK_ENDPOINT_BASE}/slack-webhook-receiver`;
export const SLACK_WEBHOOK_DIAGNOSTIC = `${SLACK_ENDPOINT_BASE}/slack-webhook-diagnostic`;
export const SLACK_BOT_TEST = `${SLACK_ENDPOINT_BASE}/slack-bot-test`;

// Legacy URLs (keeping for backward compatibility)
const BASE_SLACK_ENDPOINT = `${window.location.origin}/api/slack`;
export const WEBHOOK_URL = `${BASE_SLACK_ENDPOINT}/events`;
export const INTERACTIVE_URL = `${BASE_SLACK_ENDPOINT}/interactive`;
export const COMMANDS_URL = `${BASE_SLACK_ENDPOINT}/commands`;
